export const acMapPublication = (publication) => {
  if (!publication) {
    return null;
  }

  return {
    ...publication,
    title: publication.title || publication.titel,
    description: publication.description || publication.beschrijving,
    summary: publication.summary || publication.samenvatting,
    category: publication.category || publication.categorie || publication.tooiCategorieNaam,
    published: publication.publicatiedatum || publication.published,
  };
};
